<script lang="ts" setup>
import type { ItemListFiltersState } from '@autobid/ui/composables/carsList/useFilter'
import type { Counters } from '@autobid/ui/types/components/CarsList'
import { injectFilterComposable } from '@autobid/ui/utils/carsList/injectFilterComposable'
import { computed } from 'vue'

interface Props {
  counters: Counters
}

const props = defineProps<Props>()

const { t } = useI18n()
const useFilter = injectFilterComposable()
const {
  filters: { stage },
} = useFilter()

interface Option {
  id: ItemListFiltersState['stage']
  label: string
  counter: number
}

const stages = computed((): Option[] => {
  const { allstages, inauction, finished } = props.counters

  return [
    {
      id: 'all',
      label: t('cars-list.filters.statuses.all'),
      counter: allstages ?? 0,
    },
    {
      id: 'online',
      label: t('cars-list.filters.statuses.online'),
      counter: inauction ?? 0,
    },
    {
      id: 'finished',
      label: t('cars-list.filters.statuses.finished'),
      counter: finished ?? 0,
    },
  ]
})

function handleFilter(isAdding: boolean, value: ItemListFiltersState['stage']) {
  stage.value = isAdding ? value : undefined
}
</script>

<template>
  <common-filters-checkboxes-wrapper>
    <ElementsCheckbox
      v-for="{ id, label, counter } in stages"
      :key="id"
      class="[&>*]:text-[#58585A]"
      :checked="stage === id"
      :disabled="counter === 0"
      :label-suffix="counter"
      :label="label"
      :small="true"
      uncheck-if-disabled
      @change="(isAdding: boolean) => handleFilter(isAdding, id)"
    />
  </common-filters-checkboxes-wrapper>
</template>
